import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule as AngularCommonModule } from '@angular/common';
import { AuthModule } from './auth';
import { ConfigsModule, AppConfigService } from './configs';
import { BaseModule } from './base';
import { FormsModule as DexioFormsModule } from './forms';
import { ViewerModule } from './viewer';



@NgModule({
  imports: [
    AngularCommonModule,
    AuthModule.forRoot(),
    BaseModule,
    ConfigsModule,
    DexioFormsModule,
    ViewerModule
  ]
})
export class CommonModule {
  static forRoot(configurationUrl: string): ModuleWithProviders<CommonModule> {
    return {
      ngModule: CommonModule,
      providers: [
        {
          provide: APP_INITIALIZER,
          useFactory: (initializer: AppConfigService) => () => initializer.loadConfigurations(configurationUrl),
          deps: [ AppConfigService ],
          multi: true
        }
      ]
    };
  }
}
